import { render } from "./QuestionManagement.vue?vue&type=template&id=ff099c80"
import script from "./question_management.js?vue&type=script&lang=js&external"
export * from "./question_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__